const base = '/requirements'

const routes = {
  root: base,
}

export default routes
